module.exports = __webpack_public_path__ + "static/img/client-7.b20980d7.png";